import { z } from "zod";
export const ExplainerDismissalKey = z
    .string()
    .min(1)
    .max(120)
    .regex(/^[a-z0-9._:-]+$/);
export const ExplainerDismissal = z.object({
    key: ExplainerDismissalKey,
    dismissedAt: z.string(),
});
export const ListExplainerDismissalsResponse = z.object({
    dismissals: z.array(ExplainerDismissal),
    dismissedKeys: z.array(ExplainerDismissalKey),
});
export const DismissExplainerParams = z.object({
    key: ExplainerDismissalKey,
});
export const DismissExplainerResponse = z.object({
    dismissal: ExplainerDismissal,
});
//# sourceMappingURL=explainers.js.map